import React, { useState } from "react";
import { ChatLeftDotsFill, ChevronLeft } from "react-bootstrap-icons";
import AccardionItem from "../Accardion/AccardionItem/AccardionItem";
import Style from "./Accardion7.module.scss";

const Accardion7 = () => {
  const [openAll, setOpenAll] = useState(false);

  const categoryData = [
    {
      id: "1",
      title: "افزودن دسته بندی فروشگاه ",
      link: "/addnewcategory",
      active: window.location.pathname === "/addnewcategory",
    },
    {
      id: "2",
      title: "ویرایش دسته بندی محصولات",
      link: "/editproductscategory",
      active: window.location.pathname === "/editproductscategory",
    },
    {
      id: "3",
      title: "لیست دسته بندی سطح اول فروشگاه",
      link: "/firstcategorylist",
      active: window.location.pathname === "/firstcategorylist",
    },
    {
      id: "4",
      title: "لیست دسته بندی سطح دوم فروشگاه",
      link: "/secondcategorylist",
      active: window.location.pathname === "/secondcategorylist",
    },
    {
      id: "5",
      title: "افزودن دسته بندی رستوران",
      link: "/addresturantcategory",
      active: window.location.pathname === "/addresturantcategory",
    },
    {
      id: "6",
      title: "لیست دسته بندی رستوران",
      link: "/resturantcategorylist",
      active: window.location.pathname === "/resturantcategorylist",
    },
  ];
  let value = false;
  categoryData.forEach((element) => {
    if (element.active) {
      value = true;
    }
  });
  const openHandlerAll = () => {
    if (openAll) {
      setOpenAll(false);
    } else {
      setOpenAll(true);
    }
  };
  return (
    <div className={Style.componentHolder}>
      <div
        className={value || openAll ? Style.background : Style.accardionTitle}
        onClick={openHandlerAll}
      >
        <ChevronLeft />
        <div className={Style.right}>
          <p className={Style.accardionText}>دسته بندی</p>
          <ChatLeftDotsFill />
        </div>
      </div>
      <div className={value ||openAll ? Style.inneraccardionContent : Style.hidden}>
        <AccardionItem accardonItem={categoryData && categoryData} />
      </div>
    </div>
  );
};

export default Accardion7;
